import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";

import {
  blackShade23,
  border25,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import VariantMainProductCard from "../VariantInventoryTabs/VariantMainProductCard";
import EmptyCard from "../../../components/Cards/EmptyCard";
import {
  getLowStockChildVariantProducts,
  getOutOfStockChildVariantProducts,
  handleLowStockVariantUpdateChange,
  handleOutOfStockUpdateChange,
  handleOutOfStockVariantUpdateChange,
} from "../../../reducers/inventory/inventorySlice";
import LowStockChildProductList from "../VariantInventoryTabs/LowStockChildProductList";
import OutOfStockChildProductList from "../VariantInventoryTabs/OutOfStockChildProductList";
import MobileVariantInventory from "../Mobile/MobileVariantInventory";
import OutOfStockVariantInventory from "../Mobile/OutOfStockVariantInventory";
import ThreeDotLoader from "../../../components/ThreeDotLoader";
import { getDiscountPercentage } from "../../../utils/helper";

function OutOfStockWithVariance({ products }) {
  const [selectedMainVariant, setSelectedMainVariant] = useState(null);

  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const {
    outOfStockChildVariantProducts,
    outOfStockChildVariantProductHeader,
    outOfStockChildVariantProductsLoader,
    outOfStockVariantProductsLoader,
  } = useSelector((state) => state.inventory);

  const dispatch = useDispatch();

  const fetchChildVariants = (product) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    setSelectedMainVariant({
      id: product?.productId,
      name: product?.productName,
    });

    dispatch(
      getOutOfStockChildVariantProducts({
        businessId,
        masterProductVariantId: product?.variantInfo?.masterProductVariantId,
        status: "out_of_stock",
      })
    );
  };

  // handle Input Value Change
  const handleInputChange = (value, index) => {
    dispatch(
      handleOutOfStockVariantUpdateChange({
        outOfStockProducts: outOfStockChildVariantProducts,
        value,
        index,
      })
    );
  };

  useEffect(() => {
    if (products?.length > 0) {
      fetchChildVariants(products?.[0]);
    }
  }, [products]);
  return (
    <Box width={{ md: "calc(100vw - 270px)", xs: "100%" }} pb={1} mt={1.6}>
      {outOfStockVariantProductsLoader ? (
        <ThreeDotLoader />
      ) : products?.length === 0 ? (
        <EmptyCard
          msg={
            "You have an up to date inventory, No product with variant are Out of Stock"
          }
          icon={<ContentPasteIcon sx={{ fontSize: "24px" }} />}
        />
      ) : matches ? (
        <Box
          sx={{
            backgroundColor: whiteColor,
            p: "5px 15px 15px",
            border: border25,
            borderRadius: "10px",
          }}
        >
          <Grid container columnSpacing={2}>
            <Grid item md={3}>
              <Typography
                fontSize={13}
                fontWeight={600}
                lineHeight={1.5}
                color={blackShade23}
                py={"5px"}
              >
                Main Variants
              </Typography>
              <Box
                sx={{
                  backgroundColor: whiteColor,
                  borderRadius: "10px",
                  border: border25,
                  overflow: "hidden",
                }}
              >
                <Box sx={styles.mainProductSection}>
                  {products?.map((item, index) => (
                    <VariantMainProductCard
                      key={index}
                      img={item?.productPhoto?.[0]?.docURL}
                      originalAmt={item?.productOriginalPrice}
                      amt={item?.productSalePrice}
                      priceOff={getDiscountPercentage(
                        item?.productSalePrice,
                        item?.productOriginalPrice
                      )}
                      ondcEnabled={item?.ondcEnabled?.toLowerCase() == "yes"}
                      productName={item?.productName}
                      active={item?.productId === selectedMainVariant?.id}
                      onMainProductClick={() => fetchChildVariants(item)}
                      count={item?.count || "X"}
                    />
                  ))}
                </Box>
              </Box>
            </Grid>
            <Grid item md={9}>
              {outOfStockChildVariantProducts?.length == 0 &&
              !outOfStockChildVariantProductsLoader ? (
                <EmptyCard
                  msg={
                    "You have an up to date inventory, No products are Out of Stock"
                  }
                  icon={<ContentPasteIcon sx={{ fontSize: "24px" }} />}
                />
              ) : (
                <OutOfStockChildProductList
                  products={outOfStockChildVariantProducts}
                  tableHeader={outOfStockChildVariantProductHeader}
                  handleInputChange={handleInputChange}
                  name={selectedMainVariant?.name}
                />
              )}
            </Grid>
          </Grid>
        </Box>
      ) : (
        <MobileVariantInventory products={products} status={"out_of_stock"} />
      )}
    </Box>
  );
}

export default OutOfStockWithVariance;

const styles = {
  mainProductSection: {
    maxHeight: "47vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },
};
